import React from "react";
const LogoWhite = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 531 135"
    {...props}
  >
    <defs>
      <style>
        {
          ".cls-1{fill:#010101;}.cls-2{fill:#00a14b;}.cls-3{fill:none;stroke:#010101;stroke-width:0.71px;}"
        }
      </style>
    </defs>
    <title>{"BWCNC_Logo_Simples_Clean"}</title>
    <path
      className="cls-1"
      d="M13.92,90V27h43q10.34.09,15.72,3.58t6.51,11.68q.4,6.29-2.66,9.86T66.38,58v.18A20.45,20.45,0,0,1,72.75,60a18.57,18.57,0,0,1,4.9,3.36,14.05,14.05,0,0,1,3.08,4.38,11.84,11.84,0,0,1,1.09,4.8Q81.82,80,78,83.86a18.47,18.47,0,0,1-9.81,5A73.12,73.12,0,0,1,53.65,90ZM35.64,42.26v9.55H50.9a4,4,0,0,0,2.66-1.33A4.92,4.92,0,0,0,55,46.93a4.45,4.45,0,0,0-1.68-3.62,4.72,4.72,0,0,0-2.5-1.05Zm0,23.33V77.23h14A10.78,10.78,0,0,0,56,75.66q2.7-1.69,2.7-4.18a4.33,4.33,0,0,0-2.2-4.32,12.7,12.7,0,0,0-6.82-1.57Z"
    />
    <path
      className="cls-1"
      d="M103.23,27V64.24c-.18,4.24.64,7.19,2.44,8.85s4.62,2.55,8.46,2.66a12,12,0,0,0,7.72-2.7q3.09-2.62,2.92-8.81V27h20.5V63.93q-.14,7.86-2.6,12.54a25.36,25.36,0,0,1-6.23,7.83A27,27,0,0,1,127,89.18,46.6,46.6,0,0,1,114.3,91.1a55.43,55.43,0,0,1-11.79-1.59A30.6,30.6,0,0,1,92,84.91a21,21,0,0,1-6.89-8.07Q82.74,71.92,82.73,64V27Z"
    />
    <path
      className="cls-1"
      d="M215,27V71.22h-18l-4.71-6q7.32-1.74,11.25-4.8a16.11,16.11,0,0,0,5.5-7.59q1.56-4.53-.18-12.9a19.24,19.24,0,0,0-7.15-8.9,26.21,26.21,0,0,0-12.47-4h-41V90h22.76V69.17l20,20.8h44.48V27ZM189.7,53.36a5.18,5.18,0,0,1-2.75.94H171.08V42.7h15.83a4.69,4.69,0,0,1,2.59,1.15c1,.77,1.62,2.37,1.77,4.78Q191.18,52.43,189.7,53.36Z"
    />
    <path className="cls-1" d="M239.89,90V27h20.5V71.22h34.1V90Z" />
    <path
      className="cls-2"
      d="M344.21,73.49h20.32V99.35c0,13.55-5.7,26.49-23.71,26.49h-4.16c-19.71,0-24.17-12.78-24.17-27.1V34.07c0-13.86,6.16-26,24.17-26h4.16c19.71,0,23.71,12.16,23.71,25.25V52.55H344.21V34.07c0-4.31-1.39-6.62-5.24-6.62s-5.08,2.16-5.08,6.62V98.74c0,4.62,1.69,6.93,5.23,6.93,3.7,0,5.09-2.77,5.09-6.93Z"
    />
    <path
      className="cls-2"
      d="M404.87,9.44l14,58.5V9.44h18.17V124h-17.4L403.79,61.17V124H385.62V9.44Z"
    />
    <path
      className="cls-2"
      d="M490.16,73.49h20.33V99.35c0,13.55-5.7,26.49-23.71,26.49h-4.16c-19.71,0-24.17-12.78-24.17-27.1V34.07c0-13.86,6.15-26,24.17-26h4.16c19.7,0,23.71,12.16,23.71,25.25V52.55H490.16V34.07c0-4.31-1.38-6.62-5.23-6.62s-5.08,2.16-5.08,6.62V98.74c0,4.62,1.69,6.93,5.23,6.93,3.7,0,5.08-2.77,5.08-6.93Z"
    />
    <line className="cls-3" x1={15.49} y1={100.1} x2={15.49} y2={116.97} />
    <line className="cls-3" x1={294.49} y1={100.1} x2={294.49} y2={118.1} />
    <line className="cls-3" x1={20.57} y1={107.99} x2={289.4} y2={109.08} />
    <polygon
      className="cls-1"
      points="21.59 111.53 15.49 107.97 21.62 104.46 21.59 111.53"
    />
    <polygon
      className="cls-1"
      points="288.35 112.61 294.49 109.1 288.38 105.54 288.35 112.61"
    />
  </svg>
);
export default LogoWhite;